import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDialogComponent } from './product-dialog.component';



@NgModule({
  declarations: [ProductDialogComponent],
  imports: [
    CommonModule
  ]
})
export class ProductDialogModule { }
